import { toMoney } from "shared/utils";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { Section } from "views/applications-id-report/components/Section";
import { Stat } from "views/applications-id-report/components/Stat";
import { Asset } from "shared/app/IdentityVerificationReport/types";
import InfoIcon from "shared/icons/status-icons/info-icon.svg?react";
import { AssetItem } from "views/applications-id-report/components/SmartRender/AssetItem";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useState } from "react";
import { Applicant } from "types/application";
import { EditHousingAssistanceModal } from "./EditHousingAssistanceModal";

export const HousingAssistanceSlice = ({
  assets,
  amountCents,
  incomeId,
  applicant,
  verificationId
}: {
  assets: Asset[];
  amountCents: number;
  incomeId?: number;
  applicant: Applicant;
  verificationId?: number;
}) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <EditHousingAssistanceModal
        opened={openModal}
        onClose={() => setOpenModal(false)}
        applicant={applicant}
        amountCents={amountCents}
        verificationId={verificationId}
      />
      <Section sectionTitle="Housing assistance" data-income-id={incomeId}>
        <div className="flex items-start justify-between mt-4 mb-8">
          <Stat
            title="Monthly assistance amount"
            value={toMoney(amountCents / 100)}
          />
          <Button
            type="button"
            variant={ButtonVariant.TEXT}
            size={ButtonSize.XS}
            onClick={() => setOpenModal(true)}
          >
            Edit income source
          </Button>
        </div>

        <ContentTitle title="Vouchers">
          {assets.length > 0 ? (
            <>
              {assets.map((asset, aIdx) => (
                <AssetItem
                  key={aIdx}
                  url={asset.asset?.url || ""}
                  content_type={asset.asset?.content_type || ""}
                  assetName={asset.asset?.filename || "Voucher document"}
                />
              ))}
              <div className="flex items-center gap-4 !mt-6">
                <InfoIcon className="text-warning-500 h-5" />
                <p className="text-content-400 font-medium">
                  Fraud check not available for vouchers. Please manually review
                  the documents
                </p>
              </div>
            </>
          ) : (
            <p className="text-base text-content-500">No vouchers uploaded</p>
          )}
        </ContentTitle>
      </Section>
    </>
  );
};
